import React, { useState } from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Paper, 
  Typography, 
  Chip, 
  CircularProgress 
} from '@mui/material';

interface CommandInputProps {
  onExecute: (command: string) => void;
  isProcessing: boolean;
}

const CommandInput: React.FC<CommandInputProps> = ({ onExecute, isProcessing }) => {
  const [command, setCommand] = useState('');

  const handleExecute = () => {
    if (command.trim() && !isProcessing) {
      onExecute(command);
    }
  };

  // Example commands for the user
  const exampleCommands = [
    'Generate a playlist "90s rock classics"',
    'Create playlist "Summer Vibes" with description "Perfect for sunny days"',
    'Show me details of my first playlist',
    'List my playlists',
    'Generate a workout playlist with high energy songs'
  ];

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <TextField
          fullWidth
          label="Enter a command"
          variant="outlined"
          value={command}
          onChange={(e) => setCommand(e.target.value)}
          placeholder="e.g., List my playlists, Create a new playlist, Generate a workout playlist"
          multiline
          rows={2}
          disabled={isProcessing}
          sx={{ mr: 2 }}
        />
        <Button
          variant="contained"
          onClick={handleExecute}
          disabled={!command.trim() || isProcessing}
          sx={{ height: '56px', minWidth: '100px' }}
        >
          {isProcessing ? <CircularProgress size={24} /> : 'Execute'}
        </Button>
      </Box>
      
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2" gutterBottom>
          Example commands:
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {exampleCommands.map((cmd, index) => (
            <Chip 
              key={index} 
              label={cmd} 
              onClick={() => setCommand(cmd)} 
              clickable
              color="primary"
              variant="outlined"
            />
          ))}
        </Box>
      </Box>
    </Paper>
  );
};

export default CommandInput;
